module.exports = __webpack_public_path__ + "img/status_validate_implementation.b95c29b1.gif";